import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { PAIN_POINTS } from './salesData';
export function PainSection() {
  return <section className="bg-cream py-16 sm:py-24" data-id="element-203" data-mp="38vkg8guarrwb">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-204" data-mp="2ux4244u3uz45">
        <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-205" data-mp="2yzqz0k5mva87">
          ¿Cuántos domingos más vas a perder así?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/70" data-id="element-206" data-mp="2l6rjii5upg0n">
          Sos dueña de una estética. Amás lo que hacés. Pero nadie te dijo que ibas a pasar los
          domingos pensando qué publicar, armando stories que no convierten y respondiendo mensajes
          con solo el precio esperando que alguien reserve.
        </p>
        <p className="mt-4 font-display text-xl font-bold text-rose-deep" data-id="element-207" data-mp="229q74c9ywdmo">
          No es falta de talento. Es falta de un sistema.
        </p>

        <ul className="mx-auto mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-208" data-mp="2781mt3my1ict">
          {PAIN_POINTS.map((p, i) => <motion.li key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 rounded-xl border border-rose/10 bg-white p-4 shadow-sm" data-id="element-209" data-mp="3rp3s8s7cztmz" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-rose/10" data-id="element-210" data-mp="38x2l72kfkx2h">
                <XIcon className="h-4 w-4 text-rose-deep" data-id="element-211" data-mp="33vd9dkpdwfdc" />
              </span>
              <span className="text-sm leading-relaxed text-ink/75" data-id="element-212" data-mp="3inx9ech8m6qk">{p}</span>
            </motion.li>)}
        </ul>

        <p className="mt-10 font-display text-2xl font-bold italic text-ink sm:text-3xl" data-id="element-213" data-mp="3dtjd87ur3vku">
          ¿Y si este fuera el último domingo que pasás así?
        </p>
      </div>
    </section>;
}